import environment from './environment';

export default {
  fetch(api: string) {
    return fetch(environment.apiUrl + api).then((response: Response) =>
      response.json(),
    );
  },
};
